module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter00",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/frw.htm"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('ol', {
    staticClass: "roman"
  }, [_c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("Amritsar. House of Commons. July 8, 1920")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("Dominion Status. Written for the "), _c('em', [_vm._v("Daily Mail")]), _vm._v(". November 1929")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("The Round Table Conference. Cannon Street, City of London. December 12, 1930")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("The Landslide. House of Commons. January 26, 1931")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("A General View. Free Trade Hall, Manchester. January 30, 1931")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("A Disease of the Will. Philharmonic Hall, Liverpool. March 5, 1931")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("Conservative Differences on India. West Essex Conservative Association. February 23, 1931")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("The Gandhi-Irwin Pact and its Consequences. House of Commons. March 12, 1931")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("Our Duty in India. Albert Hall. March 18, 1931")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("Towards the Deadlock. Constitutional Club. March 26, 1931")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 66
// module chunks = 0